// extracted by mini-css-extract-plugin
export default {"owner":"OwnershipInput-module--owner--8b407"};